<template>
  <a-modal :visible="visible" :title="title" :width="800" @cancel="handleCancel">
    <a-form-model
      :key="id"
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item :label="$t('user.columns.name')" prop="realName">
        <a-input v-model="form.realName" />
      </a-form-model-item>
      <a-form-model-item :label="$t('user.columns.mobile')" prop="username">
        <a-input style="width: 70%;" v-model="form.username" />
        <a-checkbox style="float: right;" v-model="shouldMobileValid" @change="handleMobileValidChange(lang)">{{ $t('user.OpenCheck') }}</a-checkbox>
      </a-form-model-item>
      <a-form-model-item :label="$t('user.columns.loginPlatform')" prop="loginPlatform" required>
        <a-select v-model="form.loginPlatform">
          <a-select-option :value="0">{{ $t('common.all') }}</a-select-option>
          <a-select-option :value="1">{{ $t('user.modal.mobile') }}</a-select-option>
          <a-select-option :value="2">{{ $t('user.modal.PC') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <template v-if="!isAgent">
        <a-form-model-item :label="$t('user.modal.organization')" prop="organizationId" style="position: relative">
          <a-input
            @focus="handleOFocus"
            :placeholder="organizationNamePlaceholder"
            :disabled="organizationHasNoPersion"
            class="organizationId"
            style="cursor: pointer"
            v-model="organizationName"
            @keyup="handleSearch('getOrganizationList')"
          />
          <ul
            class="companyList"
            v-show="isOrganizationsShow && (organizations_searchResult.length || isOrganizationLoading)"
          >
            <li v-show="isOrganizationLoading">
              <a-spin />
            </li>
            <TreeNodes
              v-for="item in organizations_searchResult"
              :key="item.id"
              :item="item"
              :selectedId="form.organizationId"
              :recordId="handleSelectOrganization"
            />
          </ul>
        </a-form-model-item>
        <a-form-model-item :label="$t('user.columns.role')" prop="roleId" style="position: relative">
          <a-input
            @focus="handleRFocus"
            :placeholder="roleNamePlaceholder"
            :disabled="roleHasNoPermission"
            class="organizationId"
            style="cursor: pointer"
            v-model="roleName"
            @keyup="handleSearch('getRoleList')"
          />
          <ul class="companyList" v-show="isRolesShow && (roles_searchResult.length || isRoleLoading)">
            <li v-show="isRoleLoading">
              <a-spin />
            </li>
            <TreeNodes
              v-for="item in roles_searchResult"
              :key="item.id"
              :item="item"
              :selectedId="form.roleId"
              :recordId="handleSelectRole"
            />
          </ul>
        </a-form-model-item>
        <a-form-model-item :label="$t('user.modal.deviceModifyCnt')">
          <a-input-number style="width: 100%;" v-model="form.deviceModifyCnt" />
        </a-form-model-item>
        <a-form-model-item :label="$t('user.modal.allowedDeviceTypes')">
          <a-select mode="multiple" v-model="form.allowDeviceType">
            <a-select-option
              v-for="t in deviceTypes"
              :key="t.value"
            >
              {{ t.text }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('user.modal.authorities')">
          <div data-v-1ac917c8 tabindex="-1" class="ant-select ant-select-enabled">
            <div
              role="combobox"
              aria-autocomplete="list"
              aria-haspopup="true"
              aria-controls="c38ed750-2683-4dd7-81d9-3cf691d34b3a"
              class="ant-select-selection ant-select-selection--multiple"
              @click="showAModal"
            >
              <div class="ant-select-selection__rendered">
                <ul>
                  <li
                    v-for="(s, i) in selectedAuthorities"
                    :key="s.id"
                    unselectable="on"
                    role="presentation"
                    :title="s['zh-CN']"
                    class="ant-select-selection__choice"
                    style="user-select: none;"
                  >
                    <div class="ant-select-selection__choice__content">{{ s['zh-CN'] }}</div>
                    <span class="ant-select-selection__choice__remove" @click.stop="removeAS(i)">
                      <i
                        aria-label="图标: close"
                        class="anticon anticon-close ant-select-remove-icon"
                      >
                        <svg
                          viewBox="64 64 896 896"
                          data-icon="close"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                          focusable="false"
                          class
                        >
                          <path
                            d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
                          />
                        </svg>
                      </i>
                    </span>
                  </li>
                  <li class="ant-select-search ant-select-search--inline">
                    <div class="ant-select-search__field__wrap">
                      <input autocomplete="off" value class="ant-select-search__field" />
                      <span class="ant-select-search__field__mirror">&nbsp;</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item :label="$t('user.modal.sac')">
          <div data-v-1ac917c8 tabindex="-1" class="ant-select ant-select-enabled">
            <div
              role="combobox"
              aria-autocomplete="list"
              aria-haspopup="true"
              aria-controls="c38ed750-2683-4dd7-81d9-3cf691d34b3a"
              class="ant-select-selection ant-select-selection--multiple"
              @click="showCModal"
            >
              <div class="ant-select-selection__rendered">
                <ul>
                  <li
                    v-for="(s, i) in selectedCustomers"
                    :key="s.id"
                    unselectable="on"
                    role="presentation"
                    :title="s.company"
                    class="ant-select-selection__choice"
                    style="user-select: none;"
                  >
                    <div class="ant-select-selection__choice__content">{{ s.company }}</div>
                    <span class="ant-select-selection__choice__remove" @click.stop="removeAC(i)">
                      <i
                        aria-label="图标: close"
                        class="anticon anticon-close ant-select-remove-icon"
                      >
                        <svg
                          viewBox="64 64 896 896"
                          data-icon="close"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                          focusable="false"
                          class
                        >
                          <path
                            d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
                          />
                        </svg>
                      </i>
                    </span>
                  </li>
                  <li class="ant-select-search ant-select-search--inline">
                    <div class="ant-select-search__field__wrap">
                      <input autocomplete="off" value class="ant-select-search__field" />
                      <span class="ant-select-search__field__mirror">&nbsp;</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </a-form-model-item>
      </template>
      <a-form-model-item :label="$t('user.modal.appVersion')">
        <a-input v-model="form.appVersion" />
      </a-form-model-item>
      <a-form-model-item :label="$t('user.columns.requiredCaptcha')">
        <a-switch :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" v-model="form.requiredCaptcha" />
      </a-form-model-item>
      <a-form-model-item :label="$t('user.columns.enabled')">
        <a-switch :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" v-model="form.enabled" />
      </a-form-model-item>
      <a-form-model-item v-if="titleStatus === 'edit'" label="Logo" label-width="100px">
        <div class="upload">
          <el-button @click="showFileModal">{{ $t('buttons.uploadPic') }}<i class="el-icon-upload el-icon--right"></i></el-button>
          <input
            ref="InputFileDOm"
            class="file"
            type="file"
            :accept="'.mp4,.jpg,.jpeg,.png,.webm'"
            :limit="1"
            v-if="isInputShow"
            @change="hadnleFileCHnage($event, '0')"
          />
          <div class="upload-demo" data-v-1ab1ffd8="">
            <ul
              class="el-upload-list el-upload-list--text"
              :key="fileList.length"
            >
              <li
                tabindex="0"
                v-for="(file, index) in fileList"
                :key="srcList[index].id"
                style="float: left;width: 100px; height: 100px; position: relative"
                @mouseover="srcList[index].isMaskShow = true; $forceUpdate()"
                @mouseleave="srcList[index].isMaskShow = false; $forceUpdate()"
              >
                <div v-show="srcList[index].isMaskShow" class="mask" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, .3); z-index: 100; display: flex; justify-content: center; align-items: center; cursor: pointer;">
                  <a-icon type="eye" style="color: #ccc; font-size: 20px; margin-right: 10px" @click="previewImg(index)" />
                  <a-icon type="delete" style="color: #ccc; font-size: 20px" @click="rF(index)" />
                </div>
                <img :src="srcList[index].path" style="width: 100%; height: 100%; object-fit: contain; cursor: pointer" />
              </li>
            </ul>
          </div>
        </div>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleCancel">{{ $t('common.cancelText') }}</a-button>
      <a-button
        v-if="authorities.find(a => a.code === 'auth:user:password:reset') && form.id"
        key="custom"
        type="primary"
        @click="resetP"
      >{{ $t('user.modal.resetPassword') }}</a-button>
      <a-button key="submit" type="primary" @click="submitForm">{{ $t('buttons.save') }}</a-button>
    </template>
    <a-modal v-model="isAShow" title="权限列表" :width="800" class="authoritiesList" @ok="confirmA">
      <a-table
        :loading="isALoading"
        :columns="aColumns"
        :data-source="authoritiesList"
        row-key="id"
        :row-selection="{ selectedRowKeys: selectedA, onChange: selectA }"
      >
        <template v-slot:requiredCaptcha="text">
          {{ text ? '是' : '否' }}
        </template>
        <template v-slot:icon="text">
          <a-icon :type="text" style="font-size: 20px" />
        </template>
        <template v-slot:enabled="text">
          {{ text ? '是' : '否' }}
        </template>
      </a-table>
    </a-modal>
    <a-modal v-model="isCShow" title="客户列表" :width="1200" class="customersList" @ok="confirmC" :afterClose="clearCustomerModalInfo">
      <a-table
        :loading="isCLoading"
        :columns="cColumns"
        :data-source="customersList"
        :pagination="customerPagination"
        row-key="id"
        :row-selection="{ selectedRowKeys: selectedC, onChange: selectC }"
        @change="handleCustomerTablePageChange"
      >
        <template v-slot:requiredCaptcha="text">
          {{ text ? '是' : '否' }}
        </template>
        <template v-slot:icon="text">
          <a-icon :type="text" style="font-size: 20px" />
        </template>
        <template v-slot:enabled="text">
          {{ text ? '是' : '否' }}
        </template>
      </a-table>
    </a-modal>
  </a-modal>
</template>

<script>
import TreeNodes from './TreeNodes.vue'
import debounce from "@/components/function/debounce"
import {
  searchOrganizationList
} from '@/api/auth/organization'

import {
  searchRoleList
} from '@/api/auth/role'
import { getDict } from '@/api/dict'
import { searchCustomerList } from '@/api/customer'

import {
  addUser,
  updateUser,
  deleteLogo,
  uploadLogo
} from '@/api/auth/user'
import { getAuthoritiesList } from '@/api/auth/menu'
import { resetPassword } from '@/api/auth/index'
import list from './authCustomer'
import { nanoid } from 'nanoid'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: true
    },
    authorities: {
      type: Array,
      required: true
    },
    closeModl: {
      type: Function,
      required: true
    },
    afterClose: {
      type: Function,
      required: true
    },
    info: {
      type: Object,
      required: false
    },
    mobile: {
      type: String,
      required: false
    },
    realName: {
      type: String,
      required: false
    }
  },
  watch: {
    async visible(v) {
      if (v) {
        if (this.getAuthorities('/menu').find(a => a.code === 'auth:authority:query')) {
          this.getAllAuth()
        }
        this.shouldMobileValid = true
        if (this.id) {
          this.titleStatus = 'edit'
          for (let key in this.form) {
            this.form[key] = this.info[key]
          }
          this.form.id = this.info.id
          this.organizationNamePlaceholder = this.organizationName = this.info.organization
          this.roleNamePlaceholder = this.roleName = this.info.role
          this.form.id = this.info.id
          this.selectedCustomers = this.info.authorizedCustomers.map(a => {
            const c = {
              company: a.company,
              id: a.customerId
            }
            this.c[c.id] = c
            return c
          })
          if (this.info.allowDeviceType) {
            this.form.allowDeviceType = this.info.allowDeviceType.split(",")
          } else {
            this.form.allowDeviceType = []
          }
        } else {
          this.titleStatus = 'add'
          if (this.realName) {
            this.form.realName = this.realName
          }
          this.organizationNamePlaceholder = this.organizationName = '客户'
          this.roleNamePlaceholder = this.roleName = '客户'
        }
        this.title = this.titleMap[this.titleStatus][this.lang]
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
        this.getPermissionOAndR()
        
        if (this.info.logo) {
          this.fileList = [{
            id: nanoid(),
            path: this.info.logo
          }]
          this.srcList.push({
            isMaskShow: false,
            id: nanoid(),
            path: this.info.logo
          })
        }
        await this.setLists('organization')
        await this.setLists('role')
        if (!this.findNode(this.roles, this.form.roleId)) {
          this.roleHasNoPermission = true
        } else {
          this.roleHasNoPermission = false
        }
        if (!this.findNode(this.organizations, this.form.organizationId)) {
          this.organizationHasNoPersion = true
        } else {
          this.organizationHasNoPersion = false
        }
      } else {
        this.selectedCustomers = []
        this.c = {}
      }
    },
    isOrganizationsShow(val) {
      if (!val && this.organizationNamePlaceholder !== '请选择归属组织' && this.organizationNamePlaceholder !== 'Please select a organization') {
        this.organizationName = this.organizationNamePlaceholder
      }
    },
    isRolesShow(val) {
      if (!val && this.roleNamePlaceholder !== '请选择角色' && this.roleNamePlaceholder !== 'Please select a role') {
        this.roleName = this.roleNamePlaceholder
      }
    },
    lang: {
      immediate: true,
      handler(v) {
        this.title = this.titleMap[this.titleStatus || 'add'][v]
        if (v === 'zh') {
          this.rules.organizationId[0].message = this.organizationNamePlaceholder = '请选择归属组织'
          this.rules.roleId[0].message = this.roleNamePlaceholder = '请选择角色'
          this.rules.realName[0].message = '请输入用户名'
          this.rules.username[0].message = '请输入手机号'
          this.rules.username[1].message = '请输入11位手机号码'
        }
        if (v === 'en') {
          this.rules.organizationId[0].message = this.organizationNamePlaceholder = 'Please select a organization'
          this.rules.roleId[0].message = this.roleNamePlaceholder = 'Please select a role'
          this.rules.realName[0].message = 'Please enter name'
          this.rules.username[0].message = 'Please enter cell phone number'
          this.rules.username[1].message = 'Please enter the 11-digit mobile number'
        }
      }
    }
  },
  components: {
    TreeNodes
  },
  data() {
    return {
      title: '新增用户',
      titleMap: {
        add: {
          zh: '新增用户',
          en: 'Add user'
        },
        edit: {
          zh: '编辑用户',
          en: 'Edit user'
        }
      },
      JDYOrganizations: [],
      JDYDepartments: [],
      JDYDepartments_searchResult: [],
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      form: {
        username: '',
        realName: '',
        admin: false,
        organizationId: 204,
        roleId: 4,
        enabled: true,
        requiredCaptcha: true,
        loginPlatform: 0,
        deviceModifyCnt: 99,
        appVersion: "",
        allowDeviceType: []
      },
      rules: {
        realName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        username: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            message: '请输入11位手机号码',
            pattern: /^[0-9]{11}$/,
            trigger: 'blur'
          }
        ],
        organizationId: [
          {
            required: true,
            message: '请选择归属组织'
          }
        ],
        roleId: [
          {
            required: true,
            message: '请选择角色'
          }
        ]
      },
      organizationNamePlaceholder: '请选择归属组织',
      roleNamePlaceholder: '请选择角色',
      organizationName: '',
      roleName: '',
      isOrganizationsShow: false,
      isRolesShow: false,
      isOrganizationLoading: false,
      isRoleLoading: false,
      organizations: [],
      organizations_searchResult: [], 
      roles: [],
      roles_searchResult: [],
      originOrganizations: [],
      originRoles: [],
      selectedAuthorities: [],
      shouldMobileValid: true,
      isAShow: false,
      isALoading: false,
      aColumns: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: () => <div>权限名称<a-input onKeyup={ e => this.handleKeyup(e, 'zh-CN') } allow-clear type="text" data-index="1" /></div>,
          dataIndex: 'zh-CN',
          key: 'zh-CN'
        },
        {
          title: <div>权限编码<a-input onKeyup={ e => this.handleKeyup(e, 'code') } allow-clear type="text" data-index="2" /></div>,
          dataIndex: 'code',
          key: 'code'
        }
      ],
      authoritiesList: [],
      authoritiesList_origin: [],
      selectedA: [],
      aPagination: {
        current: 1,
        total: 0,
        pageSize: 10
      },
      isAgent: false,
      roleHasNoPermission: false,
      organizationHasNoPersion: false,
      fileList: [],
      srcList: [],
      isInputShow: false,
      selectedCustomers: [],
      isCShow: false,
      selectedC: [],
      isCLoading: false,
      cColumns: [
        {
          title: () => {return(
            <div>
              { this.$t('customer.company') }
              <a-input
                class="customerSearch"
                allow-clear
                type="text"
                data-index="0"
                v-model={this.customerQueryParams.query[0].value}
                onKeyup={this.handleSearchCustomers}
              />
            </div>
          )},
          dataIndex: "company",
          key: "company",
          scopedSlots: {
            customRender: "company"
          }
        },
        {
          title: () => {return(
            <div>
              { this.$t('customer.address') }
              <a-input
                class="customerSearch"
                type="text"
                allow-clear
                data-index="1"
                v-model={this.customerQueryParams.query[1].value}
                onKeyup={this.handleSearchCustomers}
              />
            </div>
          )},
          dataIndex: "address",
          key: "address",
          scopedSlots: {
            customRender: "address"
          }
        },
        // {
        //   title: (
        //     <div>
        //       用户账号
        //       <span class="icons unset" style="cursor: pointer;" data-index="2">
        //         <a-icon type="caret-up" />
        //         <a-icon type="caret-down" />
        //       </span>
        //       <a-input
        //         class="customerSearch"
        //         allow-clear
        //         type="text"
        //         data-index="2"
        //       />
        //     </div>
        //   ),
        //   dataIndex: "usernames",
        //   key: "userInfos.username",
        //   scopedSlots: {
        //     customRender: "username"
        //   }
        // },
        {
          title: () => {return(
            <div>
              { this.$t('customer.realName') }
              <a-input
                class="customerSearch"
                allow-clear
                type="text"
                data-index="2"
                v-model={this.customerQueryParams.query[2].value}
                onKeyup={this.handleSearchCustomers}
              />
            </div>
          )},
          dataIndex: "realNames",
          key: "userInfos.realName",
          scopedSlots: {
            customRender: "realName"
          }
        },
        {
          title: () => {return(
            <div>
              { this.$t('customer.organizationName') }
              <a-input
                class="customerSearch"
                allow-clear
                type="text"
                data-index="3"
                v-model={this.customerQueryParams.query[3].value}
                onKeyup={this.handleSearchCustomers}
              />
            </div>
          )},
          dataIndex: "organizations",
          key: "userInfos.organizationName",
          scopedSlots: {
            customRender: "organizationName"
          }
        }
      ],
      customersList: [],
      customerQueryParams: {
        query: [
          {
            field: 'company',
            value: ''
          },
          {
            field: 'address',
            value: ''
          },
          {
            field: 'userInfos.realName',
            value: ''
          },
          {
            field: 'userInfos.organizationName',
            value: ''
          }
        ],
        filter: [],
        sort: []
      },
      customerPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      deviceTypes: []
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  created() {
    this.titleStatus = 'add'
    this.setLists('organization')
    this.setLists('role')
    this.c = {}
  },
  mounted() {
    document.addEventListener('click', this.handleGlobalClick)
    this.getDeviceTypes()
  },
  methods: {
    async getDeviceTypes() {
      try {
        const { data } = await getDict(this.lang === "zh" ? "zh-CN" : "en-US", "deviceType")
        this.deviceTypes = data.content
      } catch(e) {
        console.log(e)
        this.deviceTypes = []
      }
    },
    async setLists(target) {
      const a = this.getAuthorities('/user')
      const ooaa = {
        organization: this.getAuthorities('/organization'),
        role: this.getAuthorities('/role')
      }
      if (ooaa[target].find(a => a.code === `auth:${target}:query`)) {
        await this[`getAll${target}s`]()
        return
      }
      if (a.find(u => u.code === 'auth:user:insert:customer' || u.code === 'auth:user:update:customer')) {
        this[`searchMode_${target}`] = 'local'
        this[`${target}s`] = this[`${target}s_searchResult`] = list[`auth_${target}s`]
        return
      }
      if (a.find(u => u.code === `auth:${target}:query:onlyCustomer`)) {
        this[`searchMode_${target}`] = 'local'
        this[`${target}s`] = this[`${target}s_searchResult`] = list[`onlyCustomer_${target}`]
        return
      }
      if (a.find(u => u.code === 'agent:auth:user:insert' || u.code === 'agent:auth:user:update')) {
        this.isAgent = true
        this.form.roleId = this.form.roleId || 4
        this.form.organizationId = this.form.organizationId || 204
        this.form.deviceModifyCnt = this.form.deviceModifyCnt || 99
        return
      }
    },
    async getAllAuth() {
      this.a = {}
      try {
        const { data } = await getAuthoritiesList()
        this.authoritiesList_origin = this.authoritiesList = data.map(d => {
          d.details.forEach(dd => {
            d[dd.locale] = dd.name;
          });
          this.a[d.id] = d
          return d;
        })
        this.selectedAuthorities = (this.info.authorities || []).map(a => this.a[a])
      } catch(e) {
        console.log(e)
      }
    },
    clearForm() {
      this.form = {
        username: '',
        realName: '',
        admin: false,
        organizationId: 204,
        roleId: 4,
        enabled: true,
        requiredCaptcha: true,
        pid: '',
        loginPlatform: 0,
        fOrgId: undefined,
        fOrgName: '',
        fDeptId: undefined,
        fDeptName: '',
        deviceModifyCnt: 99,
        staffId: '',
        appVersion: "",
        allowDeviceType: []
      }
      this.organizationName = ''
      this.organizationNamePlaceholder = this.lang === 'en' ? 'Please select a organization' : '请选择归属组织'
      // this.organizations = []
      this.roleName = ''
      this.roleNamePlaceholder = this.lang === 'en' ? 'Please select a role' : '请选择角色'
      // this.roles = []
      this.selectedAuthorities = []
      this.fileList = []
      this.srcList = []
    },
    handleCancel() {
      this.closeModl()
      this.clearForm()
    },
    handleOFocus() {
      this.organizationNamePlaceholder = this.organizationName ? this.organizationName : this.lang === 'en' ? 'Please select a organization' : '请选择归属组织'
      this.organizationName = ''
      this.isOrganizationsShow = true
      this.isRolesShow = false
    },
    handleRFocus() {
      this.roleNamePlaceholder = this.roleName ? this.roleName : this.lang === 'en' ? 'Please select a role' : '请选择角色'
      this.roleName = ''
      this.isRolesShow = true
      this.isOrganizationsShow = false
    },
    searchList(a, parameter) {
      let o, result = []
      for (let i = 0 ; i < a.length; i++) {
        o = a[i]
        let flag = false
        for (let j = 0; j < o.details.length; j++) {
          if (o.details[j].name.includes(parameter)) {
            result.push(o)
            flag = true
            break
          }
        } 
        if (!flag && o.children?.length) {
          const c = this.searchList(o.children, parameter)
          if (c.length) {
            o.children = c
            result.push(o)
          }
        }
      }
      return result
    },
    handleSearch(f) {
      debounce(() => {
        this[f]()
      }, 600)
    },
    async getOrganizationList() {
      this.organizationName = this.organizationName.trim()
      if (this.searchMode_organization === 'local') {
        this.organizations_searchResult = this.searchList(JSON.parse(JSON.stringify(this.organizations)), this.organizationName)
        return
      }
      if (this.organizationName) {
        try {
          this.organizationsPage = 1
          this.isOrganizationLoading = true
          this.organizations = []
          const { data } = await searchOrganizationList(this.organizationsPage, 20, {
            query: [
              {
                field: 'details.name',
                value: this.organizationName
              }
            ],
            filter: [],
            sort: []
          })
          this.organizations = this.organizations_searchResult = data.records
        } catch(e) {
          console.log(e)
        } finally {
          this.isOrganizationLoading = false
        }
      } else {
        this.getAllorganizations()
      }
    },
    async getAllorganizations() {
      this.isOrganizationLoading = true
      try {
        let res = await searchOrganizationList(1, 1000, {
          query: [],
          filter: [],
          sort: []
        })
        if (res.data.total > 1000) {
          res = await searchOrganizationList(1, res.data.total, {
            query: [],
            filter: [],
            sort: []
          })
        }
        this.organizations = this.organizations_searchResult = res.data.records
      } catch(e) {
        console.log(e)
      } finally {
        this.isOrganizationLoading = false
      }
    },
    async getRoleList() {
      this.roleName = this.roleName.trim()
      if (this.searchMode_role === 'local') {
        this.roles_searchResult = this.searchList(JSON.parse(JSON.stringify(this.roles)), this.roleName)
        return
      }
      if (this.roleName) {
        try {
          this.rolePage = 1
          this.isRoleLoading = true
          this.roles = []
          const { data } = await searchRoleList(this.rolePage, 20, {
            query: [
              {
                field: 'details.name',
                value: this.roleName
              }
            ],
            filter: [],
            sort: []
          })
          this.roles = this.roles_searchResult = data.records
        } catch(e) {
          console.log(e)
        } finally {
          this.isRoleLoading = false
        }
      } else {
        this.getAllroles()
      }
    },
    async getAllroles() {
      this.isRoleLoading = true
      try {
        let res = await searchRoleList(1, 1000, {
          query: [],
          filter: [],
          sort: []
        })
        if (res.data.total > 100) {
          res = await searchRoleList(1, res.data.total, {
            query: [],
            filter: [],
            sort: []
          })
        }
        this.roles = this.roles_searchResult = res.data.records
      } catch(e) {
        console.log(e)
      } finally {
        this.isRoleLoading = false
      }
    },
    handleSelectOrganization(i) {
      this.form.organizationId = i.id
      this.organizationNamePlaceholder = this.organizationName = i.details.find(d => d.locale === 'zh-CN').name
      this.isOrganizationsShow = false
    },
    handleSelectRole(i) {
      this.form.roleId = i.id
      this.roleNamePlaceholder = this.roleName = i.details.find(d => d.locale === 'zh-CN').name
      this.isRolesShow = false
    },
    handleGlobalClick(e) {
      if (!['UL', 'LI', 'INPUT'].includes(e.target.nodeName)) {
        this.isOrganizationsShow = false
        this.isRolesShow = false
      }
    },
    async resetP() {
      try {
        const { message } = await resetPassword(this.form.id)
        this.$message.success(message)
      } catch(e) {
        console.log(e)
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (!this.authorities.find(a => a.code === 'auth:user:insert' || a.code === 'auth:user:update' || a.code === 'auth:user:insert:customer' || a.code === '	auth:user:update:customer' || a.code === 'agent:auth:user:insert' || a.code === 'agent:auth:user:update')) {
            if (!this.originOrganizations.find(o => o === this.form.organizationId) || !this.originRoles.find(r => r === this.form.roleId)) {
              return this.$message.warn(this.$t('messages.np'))
            }
          }
          try {
            const form = { ...this.form, pid: +this.form.pid }
            form.authorizedCustomers = this.selectedCustomers.map(s => {
              return {
                customerId: +s.id
              }
            })
            if (form.roleId === 1 || form.roleId === 2) {
              form.admin = true
            } else {
              form.admin = false
            }
            form.authorities = (this.selectedAuthorities || []).map(s => s.id)
            if (this.fileList.length && !this.fileList[0].id) {
              form.logo = ''
            } else {
              form.logo = this.info.logo
            }
            form.allowDeviceType = form.allowDeviceType.join(",")
            if (this.form.id) {
              const { message } = await updateUser(form)
              if (form.username !== this.mobile) {
                await resetPassword(form.id)
              }
              this.$message.success(message)
            } else {
              const { message } = await addUser(form)
              this.$message.success(message)
            }
            if (this.fileList.length && !this.fileList[0].id) {
              await uploadLogo({
                userId: this.info.id,
                logo: this.fileList[0]
              })
            }
            this.clearForm()
            this.afterClose(form)
          } catch(e) {
            console.log(e)
          }
        }
      })
    },
    flattenArray(arr, origin) {
      arr.forEach(i => {
        origin.push(i)
        if (i.children?.length) {
          this.flattenArray(i.children, origin)
        }
      })
    },
    async getPermissionOAndR() {
      const o = await getDict('zh-CN', 'organization')
      this.originOrganizations = o.data.content.map(c => +c.value)
      const r = await getDict('zh-CN', 'role')
      this.originRoles = r.data.content.map(c => +c.value)
    },
    searchDept(e) {
      const value = e.target.value = e.target.value?.trim() || ''

      this.JDYDepartments_searchResult = []
      let d
      for (let i = 0; i < this.JDYDepartments.length; i++) {
        d = this.JDYDepartments[i]
        if (d.name.includes(value)) {
          this.JDYDepartments_searchResult.push(d)
        }
      }
    },
    handleMobileValidChange(v) {
      if (this.shouldMobileValid) {
        this.rules.username[1].pattern = /^[0-9]{11}$/
      } else {
        this.rules.username[1].pattern = /.*/
      }
      this.form.requiredCaptcha = this.shouldMobileValid
      this.$refs.form.validateField('username', valid => {
        console.log(valid)
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    removeAS(i) {
      this.selectedAuthorities.splice(i, 1)
    },
    removeAC(i) {
      this.selectedCustomers.splice(i, 1)
    },
    showAModal() {
      this.isAShow = true
      this.selectedA = this.selectedAuthorities.map(a => a.id)
    },
    showCModal() {
      this.getCustomerList()
      this.isCShow = true
      this.selectedC = this.selectedCustomers.map(s => s.id)
    },
    handleCustomerTablePageChange(p) {
      this.customerPagination.current = p.current
      this.getCustomerList()
    },
    handleSearchCustomers(e) {
      if (e.key === 'Enter') {
        this.customerPagination.current = 1
        this.getCustomerList()
      }
    },
    async getCustomerList () {
      this.isCLoading = true
      try {
        const { data } = await searchCustomerList(this.customerPagination.current, this.customerPagination.pageSize, this.customerQueryParams)
        this.customersList = data.records.map(item => {
          item.usernames = {};
          item.realNames = {};
          item.organizations = {};
          (item.userInfos || []).forEach(u => {
            if (u.organizationName) {
              item.organizations[u.organizationName] = u.organizationName
            }
            if (u.realName) {
              item.realNames[u.realName] = u.realName
            }
            if (u.username) {
              item.usernames[u.username] = u.username
            }
          });
          item.organizations = Object.keys(item.organizations).join("，");
          item.realNames = Object.keys(item.realNames).join("，");
          item.usernames = Object.keys(item.usernames).join("，");
          return item
        });
        this.customerPagination.total = data.total
      } catch(e) {
        console.log(e)
      } finally {
        this.isCLoading = false
      }
    },
    selectA(rows) {
      this.selectedA = rows
    },
    selectC(rows) {
      this.selectedC = rows
      rows.forEach(r => {
        if (!this.c[r]) {
          this.c[r] = this.customersList.find(c => c.id === r)
        }
      })
    },
    hanldeAPageChange() {},
    confirmA() {
      this.selectedAuthorities = this.selectedA.map(s => this.a[s])
      this.isAShow = false
    },
    confirmC() {
      this.selectedCustomers = this.selectedC.map(s => this.c[s])
      this.isCShow = false
    },
    handleKeyup(e, field) {
      if (e.key === 'Enter') {
        e.target.value = e.target.value.trim()
        this.authoritiesList = this.authoritiesList_origin.filter(a => a[field].includes(e.target.value))
      }
    },
    findNode(tree, targetId) {
      for (let node of tree) {
        // 检查当前节点的 id 是否匹配
        if (node.id === targetId) {
          return node;
        }
        
        // 如果当前节点有 children，递归查找子节点
        if (node.children && node.children.length > 0) {
          const result = this.findNode(node.children, targetId);
          if (result) {
            return result;  // 找到后返回
          }
        }
      }
      return null;  // 如果没有找到，返回 null
    },
    showFileModal() {
      this.isInputShow = false
      this.$nextTick(() => {
        this.isInputShow = true
        this.$nextTick(() => {
          this.$refs.InputFileDOm.click()
        })
      })
    },
    hadnleFileCHnage(e) {
      if (!e.target.files.length) {
        return
      }
      let i
      for (i = 0; i < e.target.files.length; i++) {
        if (!this.onBeforeUpload(e.target.files[i])) {
          break;
        }
      }
      if (i == e.target.files.length) {
        this.fileList = Array.from(e.target.files)
        this.srcList = this.fileList.map(f => {
          if (f.id) {
            return f
          } else {
            return {
              id: nanoid(),
              path: '',
              isMaskShow: false
            }
          }
        })
        this.fileList.forEach((f, i) => {
          if (!f.id) {
            const fr = new FileReader()
            fr.readAsDataURL(f)
            fr.onload = e => {
              this.srcList[i] = {
                path: "data:image/png;base64," + e.target.result.substring(e.target.result.indexOf(',') + 1),
                isMaskShow: false
              }
              this.$forceUpdate()
            }
          }
        })
      }
    },
    previewImg(i) {
      const imgList = this.srcList.map(s => s.path)
      this.$hevueImgPreview({
        multiple: true,
        nowImgIndex: i,
        imgList
      })
    },
    rF(i) {
      this.$Mconfirm(this.$t('messages.ctrp'), this.$t('messages.hint'), {
        confirmButtonText: this.$t('common.okText'),
        cancelButtonText: this.$t('common.cancelText'),
        type: "warning"
      })
        .then(async () => {
          // console.log(this.fileList[i]);
          // if (this.fileList[i].id) {
          //   this.delField.push(this.fileList[i].id)
          // }
          // const arr = [...this.fileList];
          // arr.splice(i, 1);
          // this.srcList.splice(i, 1)
          // this.fileList = arr;
          // this.$forceUpdate();
          if (this.fileList[i].id) {
            await deleteLogo(this.info.id)
            this.info.logo = ''
          }
          this.fileList = []
          this.srcList = []
          this.$EM({
            type: "success",
            message: this.$t('messages.rs')
          });
          return true;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('messages.cr')
          });
        });
    },
    clearCustomerModalInfo() {
      this.customerPagination.current = 1
      for (let i = 0; i < this.customerQueryParams.query.length; i++) {
        this.customerQueryParams.query[i].value = ''
      }
      this.customersList = []
      this.selectedC = []
    },
    onBeforeUpload(file) {
      let acceptTypes;

      acceptTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "video/mp4",
        "video/webm"
      ];

      if (file.size > 1024 * 1024) {
        // 文件大于 30M 时取消上传
        this.$message.error(this.$t('messages.lessThan1MB'))
        return false;
      }
      if (!acceptTypes.includes(file.type)) {
        // 继续上传
        this.$message.error(this.$t('messages.rightFile'))
        return false; // 停止上传
      }
      return true;
    }
  }
}
</script>

<style lang="less" scoped>
.companyList {
    position: absolute;
    background-color: #fff;
    top: calc(100% + 12px);
    right: 0;
    left: 0;
    z-index: 100;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .3);
    padding: 3px 0;
    min-height: 30px;
    max-height: 420px;
    overflow: auto;
    .spin {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    li {
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      cursor: pointer;
      font-size: 14px;
      color: #777;
      &.selected {
        background-color: #e6f7ff;
      }
    }
  }
  input.file {
  display: none;
}
.el-upload-list__item {
  display: flex;
  justify-content: space-between;
}
.upload-item {
  display: flex;
  width: 60%;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}
</style>